'use client';

import { isValidLeaderUrl } from '../../../../utils/leaderRedirect';
import { Auth0 } from '@modules/auth/components/Auth0/Auth0';

import React from 'react';

export const Auth0Page: React.FC = () => {
  const params = new URLSearchParams(window.location.search);

  const returnTo = params.get('returnTo');

  if (returnTo && isValidLeaderUrl(returnTo)) {
    window.location.assign(returnTo);
  } else {
    return (
      <Auth0 />
    );
  }
};
